import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { DocumentTemplateSliderComponent } from './document-template-slider/document-template-slider.component';
import { FieldsetModule } from 'primeng/fieldset';
import { BptFileUploadModule } from 'bpt-ui-library/bpt-file-upload';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { DocumentTemplateGlobalListComponent } from './document-template-global-list/document-template-global-list.component';
import { EqmsScopeConfigurationComponent } from './eqms-scope-configuration/eqms-scope-configuration.component';
import { DocumentTemplateManagementComponent } from './document-template-management/document-template-management.component';
import { PanelModule } from 'primeng/panel';
import { BptTextInputModule } from 'bpt-ui-library/bpt-text-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { ToastModule } from 'primeng/toast';
import { PickListModule } from 'primeng/picklist';
import {TreeSelectModule} from 'primeng/treeselect';
import { WhereAmIUsedModalComponent } from './where-am-i-used-modal/where-am-i-used-modal.component';
import { DialogModule } from 'primeng/dialog';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { LabelComponent } from '../shared-components/label/label.component';

@NgModule({
  declarations: [
    DocumentTemplateSliderComponent,
    DocumentTemplateGlobalListComponent,
    EqmsScopeConfigurationComponent,
    DocumentTemplateManagementComponent,
    WhereAmIUsedModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FieldsetModule,
    BptFileUploadModule,
    ButtonModule,
    SidebarModule,
    PanelModule,
    BptTextInputModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    MessagesModule,
    BptProgressSpinnerModule,
    ToastModule,
    MessageModule,
    PickListModule,
    TreeSelectModule,
    DialogModule,
    SpinnerComponent,
    LabelComponent
  ],
  providers: [ConfirmationService, MessageService]
})
export class DocumentTemplateManagementModule { }
